import {Box, Flex, Text} from '@chakra-ui/react'
import Footer from './Footer'
import {useEffect, useRef, useState} from 'react'
import TopContent from './TopContent'
import Intro from './Intro'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateCurrentContent,
  updateCurrentIndexContent,
  updateData,
  updateSessionId,
} from '@redux/learn-part-three/learnPartThree'
import GetIdea from './GetIdea'
import PracticeIdea from './PracticeIdea'
import PracticeLesson from './PracticeLesson'
import PracticeLessonFrame1 from './PracticeLessonFrame1'
import PracticeLessonFrame2 from './PracticeLessonFrame2'
import Summary from './Summary'
import learnPartThreeRequest from '@apis/learn-part-three'
import Loading from '@components/Loading'
import Header from './Header'
import {useLocation} from 'react-router-dom'
import FormReportError from '@components/FormReportError'
import {FEATURE_REPORT_ERROR, SCREEN_REPORT_ERROR} from '@utils/Const'
import ModalVerifyClose from '@pages/ConverstationPage/components/ModalVerifyClose'

const PartThree = () => {
  const {
    data,
    currentContent,
    currentIndexContent,
    sessionId,
    messages,
    isLoadingBot,
  } = useSelector((state: any) => state.learnPartThree)
  const {lesson_id} = useLocation()?.state || {}
  const [isLoading, setIsLoading] = useState(true)
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const dispatch = useDispatch()

  useEffect(() => {
    initSession()
  }, [])

  useEffect(() => {
    if (!sessionId) return
    getData()
  }, [sessionId])

  useEffect(() => {
    if (!data?.contents) return
    dispatch(updateCurrentContent(data?.contents[currentIndexContent]))
  }, [data, currentIndexContent])

  useEffect(() => {
    if (data?.contents && data?.current_step) {
      const contentIndex = data.contents.findIndex(
        (item: any) => item.step === data.current_step,
      )
      dispatch(updateCurrentIndexContent(contentIndex))
    }
  }, [data?.contents, data?.current_step])

  const initSession = async () => {
    const params = {
      lesson_id,
    }

    const res = await learnPartThreeRequest.initSession(params)
    dispatch(updateSessionId(res?.data?.data?.session_id))
  }
  const getData = async () => {
    setIsLoading(true)

    try {
      const params = {
        session_id: sessionId,
      }
      const res = await learnPartThreeRequest.getData(params)
      dispatch(updateData(res?.data?.data))
    } catch (error) {}

    setIsLoading(false)
  }

  // Add useEffect for auto-scrolling when messages change
  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: 'smooth',
      })
    }
  }, [messages, isLoadingBot])

  const renderContent = () => {
    switch (currentContent?.type) {
      case 'P3_OVERVIEW':
        return <Intro />
      case 'P3_GET_IDEA':
        return <GetIdea />
      case 'P3_PRACTICE_IDEA':
        return <PracticeIdea />
      case 'P3_PRACTICE_LESSON_BODY':
        return <PracticeLesson />
      case 'P3_PRACTICE_LESSON_FRAME_1':
        return <PracticeLessonFrame1 />
      case 'P3_PRACTICE_LESSON_FRAME_2':
        return <PracticeLessonFrame2 />
      case 'P3_SUMMARY':
        return <Summary />
      case 'P3_WAITTING_SCREEN':
        return <></>
      default:
        return <Text>Not found</Text>
    }
  }

  return (
    <Flex
      p={{base: '16px', md: '32px'}}
      flexDirection={'column'}
      height={'100dvh'}
      bg={'#FFFFFF'}>
      {isLoading && <Loading />}
      <Header steps={data?.progresses} currentContent={currentContent} />
      <Flex
        ref={scrollContainerRef}
        flex={1}
        flexDirection={'column'}
        overflow={'auto'}
        w={'100%'}
        maxWidth={'1280px'}
        margin={'auto'}
        mt="16px"
        sx={{
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}>
        {currentContent && currentContent?.type !== 'P3_SUMMARY' && (
          <TopContent />
        )}
        <Box flex={1} bg={'#F9FAFB'} borderRadius={'24px'} padding={'24px'}>
          {renderContent()}
        </Box>
      </Flex>
      <Footer />
      <FormReportError
        feature={FEATURE_REPORT_ERROR.LESSON_PART_2}
        screen={SCREEN_REPORT_ERROR.LESSON_PART_2}
      />
      <ModalVerifyClose />
    </Flex>
  )
}

export default PartThree
